import { request } from './http';
import type { PaginatedResult } from '@/types/api';
import type {
  CustomerSummary,
  CustomerDetail,
  CustomerListQuery,
  ResetPasswordRequest,
  ResetPasswordResponse,
  ViewSensitiveRequest,
  ViewSensitiveResponse,
} from '@/types/customer';

export interface CustomerListResult extends PaginatedResult<CustomerSummary> {
  /** 当前筛选条件下所有客户钱包余额合计（不含母账户） */
  totalWalletBalanceCents: number;
  /** 管理员母账户当前余额（整数美分），未初始化时为 null */
  masterBalanceCents: number | null;
}

export const customersApi = {
  list(query?: CustomerListQuery) {
    return request<CustomerListResult>({
      url: '/admin/customers',
      method: 'GET',
      params: query,
    });
  },

  detail(id: string) {
    return request<CustomerDetail>({
      url: `/admin/customers/${id}`,
      method: 'GET',
    });
  },

  /**
   * 查看敏感字段明文（如手机/邮箱）。
   * 后端会写审计日志（操作人、原因、字段、时间、IP）。
   */
  viewSensitive(payload: ViewSensitiveRequest) {
    return request<ViewSensitiveResponse>({
      url: `/admin/customers/${payload.customerId}/sensitive`,
      method: 'POST',
      data: { fields: payload.fields, reason: payload.reason },
    });
  },

  /** 重置客户登录密码（与客户支付密码无关） */
  resetPassword(payload: ResetPasswordRequest) {
    return request<ResetPasswordResponse>({
      url: `/admin/customers/${payload.customerId}/reset-password`,
      method: 'POST',
      data: {
        newPassword: payload.newPassword,
        reason: payload.reason,
      },
    });
  },
};
